import { EMAIL_ERRORS_MAPPING } from '../../constants/email';
import { DEFAULT_FORM_ERROR } from '../../constants/form';
import { EmailErrorCode } from '../../enums/email';

export const getEmailErrorMessage = (errorCode: string) => {
  const errorMessage = EMAIL_ERRORS_MAPPING[errorCode];
  const error = {
    message: errorMessage || DEFAULT_FORM_ERROR,
    translated: false,
    withOptions: errorCode === EmailErrorCode.UserWithEmailExists,
    timestamp: Date.now(),
  };

  return error;
};
